"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessUserToJSON = exports.BusinessUserFromJSONTyped = exports.BusinessUserFromJSON = void 0;
var _1 = require("./");
function BusinessUserFromJSON(json) {
    return BusinessUserFromJSONTyped(json, false);
}
exports.BusinessUserFromJSON = BusinessUserFromJSON;
function BusinessUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': json['user'],
        'permissions': (json['permissions'].map(_1.BusinessPermissionFromJSON)),
    };
}
exports.BusinessUserFromJSONTyped = BusinessUserFromJSONTyped;
function BusinessUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': value.user,
        'permissions': (value.permissions.map(_1.BusinessPermissionToJSON)),
    };
}
exports.BusinessUserToJSON = BusinessUserToJSON;
